module.exports = __webpack_public_path__ + "media/images/flags/16/Unknown-ee8d4e492255ad1073ea7b5c737abf4e.png";